

















import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'BaseProperty',
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data(...args): any {
    return args;
  },
});
